export const LITE_SPACE_STATUSES = ['Lite'];
